module.exports = __webpack_public_path__ + "img/popup-bottom-battery-1.1a06ee47.svg";